import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { OrdersWithPayment } from '../_models/order';
import { Modules } from '../constants';

@Injectable()
export class RefreshService {

  private source = new BehaviorSubject<Modules>(null);
  current = this.source.asObservable();

  private summaryFromTab: string | null = null;
  summaryRefreshFromTab = new Subject<void>();
  private summaryOrderPayload: OrdersWithPayment | null = null;

  constructor() { }

  refreshModule(component) {

    this.source.next(component);
  }

  clear() {
    this.source.next(null);
  }

  setSummaryRefreshFromTab(tab: string) {
    this.summaryFromTab = tab;
    this.summaryRefreshFromTab.next();
  }

  setSummaryOrderPayload(order: OrdersWithPayment) {
    this.summaryOrderPayload = order;
  }

  consumeSummaryOrderPayload(): OrdersWithPayment | null {
    const v = this.summaryOrderPayload;
    this.summaryOrderPayload = null;
    return v;
  }

  consumeSummaryRefreshFromTab(): string | null {
    const v = this.summaryFromTab;
    this.summaryFromTab = null;
    return v;
  }

  clearSummaryRefreshFromTab() {
    this.summaryFromTab = null;
  }

}
